import { Route } from '@angular/router';
import { HomologationComponent } from '../homologation/homologation.component';

export const homologationRoutes: Route[] = [
  {
    path: '',
    component: HomologationComponent,
  },
];
